import { combineReducers, configureStore } from "@reduxjs/toolkit";
import graphReducer from "./slices/graphSlice";
import authReducer from "./slices/authSlice";
import selectedLeafClassesReducer from "./slices/selectedLeafClassesSlice";
import {
  persistStore,
  persistReducer,
  createTransform,
  FLUSH,
  REHYDRATE,
  PAUSE,
  PERSIST,
  PURGE,
  REGISTER,
} from "redux-persist";
import storage from "redux-persist/lib/storage";
import { createLogger } from "redux-logger";
import { enableMapSet } from "immer";

enableMapSet();

const authPersistConfig = {
  key: "auth",
  storage,
  blacklist: [],
  debug: true,
};

// Create persisted reducers
const persistedAuthReducer = persistReducer(authPersistConfig, authReducer);
const persistedGraphReducer = graphReducer;

// Combine reducers with both persistors
const rootReducer = combineReducers({
  graph: persistedGraphReducer,
  auth: persistedAuthReducer,
  selectedLeafClasses: selectedLeafClassesReducer,
});

const logger = createLogger({
  predicate: () => process.env.NODE_ENV !== "production",
});

const store = configureStore({
  reducer: rootReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        ignoredActions: [FLUSH, REHYDRATE, PAUSE, PERSIST, PURGE, REGISTER],
        ignoredPaths: [
          "graph.pinnedNodes",
          "graph.expandedNodes",
          "graph.resetableNodes",
          "graph.filters",
          "graph.allExpandedNodes",
          "graph.expandedPinnedNodes",
        ],
      },
    }).concat(logger),
  devTools: process.env.NODE_ENV !== "production",
});

export const persistor = persistStore(store);

export default store;
